import React from 'react';
import { GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';

const CustomCell = React.memo((props) => {
  let value;
  if (props.field === 'BUY_DATE' || props.field === 'CREATED_DATE' || props.field === 'LAST_UPDATE_DATE' || props.field === 'INVOICE_DATE' || props.field === 'TARGET_COMPLETION_DATE' || props.field === 'TrialActivationDate' || props.field === 'PaidDate' || props.field === 'LiveDate' || props.field === 'RENEWAL_DATE') {
    if (props.dataItem[props.field] !== '' && props.dataItem[props.field] !== "1/1/0001 12:00:00 AM") {
      const dateValue = new Date(props.dataItem[props.field]).toLocaleDateString();
      value = dateValue;
    } else {
      value = '';
    }
  } else {
    value = props.dataItem[props.field];
  }


  return (
    <td
      className={props.isSelected ? 'k-state-selected' : ''}
      colSpan={props.colSpan}
      role="gridcell"
      aria-selected={props.isSelected}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
    >
      <div className={props.field === 'CREATED_DATE' || props.field === 'LAST_UPDATE_DATE' || props.field === 'TARGET_COMPLETION_DATE' ? 'ml-3' : ''} >{value}</div>
    </td>
  );
});

export default CustomCell;
